import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    languages: [
        { val: 'en', label:"English" },
        { val: 'zh', label:"中文" }
    ],
    lan:"zh",
    modleFlag:'',
  },
  getters:{
    
  },
  mutations:{
  	lanChange(state,data){
  		state.lan=data;
    },
    modleChange(state,data){
  		state.modleFlag=data;
  	},
  },
  actions:{

  }
})



// WEBPACK FOOTER //
// ./src/plugs/vuex/index.js